import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class FarmKindProductivityModel extends BaseModel {

    constructor() {
        super({
                name: "farm_kind_productivity",
                tableName: 'farm_kind_productivity',
                label: "Năng suất theo loại",
            },
            {
                stt: {
                    name: "stt",
                    label: "STT",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                    // display: { list: true, add: false, edit: false }
                },
                id: {
                    name: "id",
                    display: false
                },
                farm_id: { 
                    name: 'farm_id',
                    display: false
                },
                kind_type_id: { 
                    name: 'kind_type_id',
                    display: false
                },
                productivity: {
                    name: 'productivity',
                    display: false,
                }

            },
            )
    }

}